<template lang="pug">
	section.product-features(v-if="isEmpty")
		.product-features__layout
			.lazyload.product-features__bg(v-if="product.acf.feature_bg" 
																			:style="{ backgroundImage: `url('/img/img-preloader.svg')` }"
																			:data-bg="product.acf.feature_bg")
			.product-features__image(v-if="product.acf.feature_image")
				img.lazyload(src="/img/preloader_search.svg"
											:data-src="product.acf.feature_image" 
											:alt="product.name + $t('pages.catalog.productImageNumber') + ((product.images.length * 2) + 1)"
											:title="$t('pages.catalog.productImageTitle') + product.name + $t('pages.catalog.productImageNumber') + ((product.images.length * 2) + 1)")

		.product-features__descr(v-if="product.acf.feature_description" v-html="product.acf.feature_description")

		.product-features__mobile-image(v-if="product.acf.feature_image")
			img.lazyload(src="/img/preloader_search.svg"
										:data-src="product.acf.feature_image" 
										:alt="product.name + $t('pages.catalog.productImageNumber') + ((product.images.length * 2) + 2)"
										:title="$t('pages.catalog.productImageTitle') + product.name + $t('pages.catalog.productImageNumber') + ((product.images.length * 2) + 2)")
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    isEmpty() {
      if (
        this.product.acf.feature_bg !== null &&
        this.product.acf.feature_description !== null &&
        this.product.acf.feature_description !== null
      ) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss">
@import '~assets/scss/helpers/vars';
@import '~assets/scss/helpers/mixins';

.product-features {
  position: relative;
  margin-top: 140px;
  padding: 120px 0 195px;

  @include laptop {
    padding: 75px 0;
  }

  @include tablet {
    margin-top: 80px;
  }

  @include mobile {
    margin-top: 60px;
    padding: 75px 0 0;
  }

  &__layout {
    position: absolute;
    z-index: -1;
    top: 0;
    left: 50%;
    width: 100vw;
    height: 100%;
    margin-left: calc(-50vw - 100px);

    @include tablet {
      margin-left: -50vw;
    }
  }

  &__bg {
    display: block;
    width: 100%;
    height: 100%;
  }

  &__image {
    position: absolute;
    top: -40px;
    right: 0;
    width: 570px;

    @include laptop {
      top: 0;
      width: 350px;
    }

    @include tablet {
      width: 360px;
    }

    @include mobile {
      display: none;
    }
  }

  &__mobile-image {
    display: none;

    @include mobile {
      display: block;
      margin-top: 30px;
      margin-left: -15px;
      margin-right: -15px;
    }
  }

  &__descr {
    width: 100%;
    max-width: 430px;
    font-size: 16px;
    line-height: 1.4;

    @include tablet {
      max-width: 360px;
    }

    @include mobile {
      max-width: 100%;
      margin: 0 auto;
    }

    h2 {
      margin-bottom: 10px;
      font-size: 24px;
      font-weight: 600;
      letter-spacing: 2px;
      text-transform: uppercase;

      @include mobile {
        margin-bottom: 25px;
        font-size: 20px;
      }
    }

    p {
      width: 100%;
      max-width: 420px;
      margin-bottom: 17px;

      @include mobile {
        margin-bottom: 25px;
      }
    }

    ul {
      padding-left: 20px;

      li {
        position: relative;
        margin-bottom: 7px;
        padding-left: 15px;
        line-height: 1.2;

        &:before {
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          @include size(4px);
          margin-top: -2px;
          border-radius: 50%;
          background-color: $blackColor;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
